import { Form, Text, NestedField, Checkbox, Field } from 'react-form';
import { emptyStringIfNull } from '../General/Helper'
import ReactModal from "react-modal";
import { isNullOrUndefined } from 'util';
import ReactTooltip from 'react-tooltip'
var formatMoney = require('../General/Helper').formatMoney;
import { AbconetApi } from '../General/AbconetApi';

var UserSelector = require('../General/Selectors/UserSelector').UserSelector;
var GroupSelector = require('../General/Selectors/GroupSelector').GroupSelector;
var Select = require('../General/Selectors/FormSelector').FormSelector;
var GeneralLedgerSelector = require('../General/Selectors/GeneralLedgerSelector').GeneralLedgerSelector;


var googleMapsKey = "AIzaSyBCy5ldKKtsCo27OxivXGbT0zh8kfVEE7E";

const statesOptions = [
    { value: 'ACT', label: 'ACT' },
    { value: 'NSW', label: 'NSW' },
    { value: 'NT', label: 'NT' },
    { value: 'QLD', label: 'QLD' },
    { value: 'SA', label: 'SA' },
    { value: 'TAS', label: 'TAS' },
    { value: 'VIC', label: 'VIC' },
    { value: 'WA', label: 'WA' },
];


export class GlAccountBudgetEditLine extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }

    }

    updateData(ev) {
        var data = this.props.budgetLine;
        data.amount = ev.target.value;
        this.props.onChange(data);
    }

    removeLine(ev) {
        ev.preventDefault();
        var data = this.props.budgetLine;
        data.amount = -1;
        this.props.onChange(data);
    }

    render() {
        var self = this;

        return <div className="row">
                   <div className="col-3">
                        {this.props.budgetLine.glAccount.name}
                   </div>
            <div className="col-3"><input type="number" value={this.props.budgetLine.amount} defaultValue={0} className="form-control add-item" onChange={self.updateData.bind(self)} /></div>
            <div className="col-1"> <span>
                <a href="#" onClick={self.removeLine.bind(this)}><i className="icon icon-close lead"></i></a>
            </span></div>
                  
               </div>;
    }
}

export class PredictionList extends React.Component {
    selectItemCallback(item) {
        var place = item.result;
        var addressParts = {};
        for (var i = 0; i < place.address_components.length; i++) {
            var addressComponent = place.address_components[i];
            var addressType = addressComponent.types[0];
            switch (addressType) {
                case 'premise':
                    addressParts.premise = addressComponent['long_name'];
                    break;

                case 'street_number':
                    addressParts.number = addressComponent['long_name'];
                    break;

                case 'route':
                    addressParts.streetName = addressComponent['long_name'];
                    break;

                case 'locality':
                    addressParts.suburb = addressComponent['long_name'];
                    break;

                case 'administrative_area_level_1':
                    addressParts.state = addressComponent['short_name'];
                    break;

                case 'postal_code':
                    addressParts.postcode = addressComponent['long_name'];
                    break;
            }
        }

        var streetAddress = `${emptyStringIfNull(addressParts.number)} ${emptyStringIfNull(addressParts.streetName)}`;

        addressParts.streetAddress = streetAddress.trim();

        // If the premise is the same as street address ignore it.
        if (addressParts.premise) {
            if (addressParts.streetAddress.toUpperCase() === addressParts.premise.toUpperCase()) {
                delete (addressParts.premise);
            }
        }

        // Add the name of the site.
        if (place.name) {
            if (addressParts.streetAddress.toUpperCase() !== place.name.toUpperCase()) {
                addressParts.name = place.name;
            }
        }

        if (place.name && addressParts.premise) {
            if (place.name.toUpperCase() === addressParts.premise.toUpperCase()) {
                delete (addressParts.premise);
            }
        }


        this.props.onSelect(addressParts);
    }


    selectItem(item) {
        AbconetApi.get(`/api/address/autocomplete/details/?id=${item.place_id}`).then(this.selectItemCallback.bind(this));
    }

    renderItem(item) {
        return <div key={item.place_id} onClick={this.selectItem.bind(this, item)} className="item">
            {item.description}
        </div>;
    }

    render() {
        if (this.props.collection == null || this.props.collection.length === 0) {
            return <div />;
        }

        return <div className="address-autocomplete">
            <div className="inner">
                {this.props.collection.map(this.renderItem.bind(this))}
            </div>
        </div>;
    }
}

export class SiteEdit extends React.Component {

    constructor(props) {
        super(props);
        var canEdit = props.initialSite.canEdit;
        if (props.initialSite.id == 0) {
            canEdit = true;
        }
        this.state = {
            isSaved: true,
            isSaving: false,
            id: 0,
            errorMessage: "",
            submittedValues: this.props.initialSite,
            permissionsModalOpen: false,
            isGroupSaved: true,
            isGroupSaving: false,
            canEdit: canEdit,
            permissions: {}
        }

    }

    componentDidMount() {
    }

    openPermissionsModal(ev) {
        ev.preventDefault();
        this.setState({
            permissionsModalOpen: true
        });
    }

    closePermissionsModal() {
        this.setState({
            permissionsModalOpen: false
        });
    }

    sendStateToServer() {
        var self = this;
        AbconetApi.post('/api/address/', this.state.submittedValues).then(response => {
            if (this.props.onCreateSite) {
                this.props.onCreateSite(response);
            }

            if (this.props.initialSite.id === 0 && response !== undefined && !this.props.miniMode) {
                window.location = `/sites/${response}`;
            }

            self.setState({ isSaved: true, errorMessage: "", isSaving: false });

        })
            .catch((error) => {
                self.setState({
                    isSaved: true,
                    isSaving: false
                });
            });
    }

    setChange(data) {
        var values = data.values;
        var searchString = values.addressLine1;
        var self = this;

        AbconetApi.get(`/api/address/autocomplete/search?term=${searchString}`).then(data => {
            self.setState({ predictionCollection: data.predictions });
        });

        this.setState({ isSaved: false });
    }

    submitSite(submittedValues) {
        if (isNullOrUndefined(submittedValues.name) || submittedValues.name === '') {
            alert('Please enter site name');

            return;
        }

        this.setState({ submittedValues, isSaving: true }, this.sendStateToServer);
    }

    onPredictionSelection(addressParts) {
        var addressLineNumber = 1;

        this.formApi.setValue('addressLine1', '');
        this.formApi.setValue('addressLine2', '');
        this.formApi.setValue('addressLine3', '');
        this.formApi.setValue('addressLine4', '');
        this.formApi.setValue('addressLine5', '');

        if (addressParts.name) {
            this.formApi.setValue(`addressLine${addressLineNumber}`, addressParts.name);
            addressLineNumber++;
        }

        if (addressParts.premise) {
            this.formApi.setValue(`addressLine${addressLineNumber}`, addressParts.premise);
            addressLineNumber++;
        }

        if (addressParts.streetAddress) {
            this.formApi.setValue(`addressLine${addressLineNumber}`, addressParts.streetAddress);
            addressLineNumber++;
        }

        this.formApi.setValue('state', addressParts.state);
        this.formApi.setValue('suburb', addressParts.suburb);
        this.formApi.setValue('postcode', addressParts.postcode);
    }


    onFocus() {
        this.setState({
            showPredictions: true
        });
    }

    onBlur() {
        var self = this;
        setTimeout(() => {
            self.setState({
                showPredictions: false
            });
        },
            800);
    }

    setGroupChange() {
        this.setState({ isGroupSaved: false });
    }

    handleCancel(ev) {
        ev.preventDefault();
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }

    renderCancelButton() {

        if (!this.props.miniMode) {
            return null;
        }

        if (!this.props.initialSite.canManageBudget && !this.props.initialSite.canEdit && this.props.initialSite.id !== 0) {
            return;
        }


        var btnText = 'Cancel';
        var btnClass = 'changes';


        return <button className={"btn btn-outline-primary " + btnClass} disabled={this.state.isSaving} onClick={this.handleCancel.bind(this)}>{btnText}</button>;
    }

    renderSaveButton() {

        if (!this.props.initialSite.canManageBudget && !this.props.initialSite.canEdit && this.props.initialSite.id !== 0) {
            return;
        }


        var btnText = 'Save';
        var btnClass = 'changes';
        if (this.state.isSaved) {
            btnText = 'Saved';
            btnClass = 'saved';
        }
        if (this.state.isSaving) {
            btnText = 'Saving';
            btnClass = 'saving';
        }

        if (!this.props.miniMode) {
            btnClass += ' float-right';
        }

        return <button className={"btn btn-primary " + btnClass} disabled={this.state.isSaved || this.state.isSaving}>{btnText}</button>;
    }

    renderGroupSaveButton() {
        var btnText = 'Save';
        var btnClass = 'changes';
        if (this.state.isGroupSaved) {
            btnText = 'Saved';
            btnClass = 'saved';
        }

        if (this.state.isGroupSaving) {
            btnText = 'Saving';
            btnClass = 'saving';
        }


        return <button className={"btn btn-primary float-right " + btnClass} disabled={this.state.isGroupSaved || this.state.isGroupSaving}>{btnText}</button>;
    }

    renderHeader() {
        if (this.props.miniMode) {
            return null;
        }

        if (this.props.initialSite.canEdit == false) {
            return null;
        }

        if (this.props.initialSite.id <= 0) {
            return <h4> Create Site </h4>;
        }

        return <h4> Edit Site </h4>;
    }

    validateLength(e, length) {
        if (e.target.value.length > length) {
            e.target.value = e.target.value.slice(0, length)
        } else {
            e.target.value;
        }
    }

    getLabelColClassName() {
        if (this.props.miniMode) {
            return 'col-6';
        }

        return 'col-sm-2';
    }

    getValueColClassName() {
        if (this.props.miniMode) {
            return 'col-6';
        }

        return 'col-sm-10';
    }

    finishEdit() {
        if (this.props.onFinishEdit) {
            this.props.onFinishEdit(this.state.submittedValues);
        }
    }

    renderFinishEditingButton() {
        if (this.props.initialSite.id === 0) {
            return;
        }

        return <button onClick={this.finishEdit.bind(this)} disabled={!this.state.isSaved} className="btn btn-outline-primary">Finish Editing</button>;
    }


    addBudgetLine(formApi, ev) {
        ev.preventDefault(); 
        var lineCollection = this.formApi.getValue("glBudgetLineCollection");
        var accountSelection = formApi.values.generalLedgerAccountCode;
        var index = -1;
        if (accountSelection == '') {
            return;
        }
        if (!isNullOrUndefined(lineCollection)) {
            index = lineCollection.findIndex(function (obj) {
                return obj.glAccount.id === accountSelection.id;
            });
        }


        if (index <= -1) {
            formApi.addValue('glBudgetLineCollection', { glAccount: accountSelection, amount: 0 });
            formApi.setValue('generalLedgerAccountCode', '');
        } else {
            alert('Account already exists on list.');
        }

        this.setState({ isSaved: false });
    }

    updateBudgetLine(index, formApi, value) {

        var lineCollection = formApi.getValue("glBudgetLineCollection");

        if (value.amount < 0) {
            lineCollection.splice(index, 1);
        }
        else {
            lineCollection[index] = value;
        }

        formApi.setValue("glBudgetLineCollection", lineCollection);

        this.setState({ isSaved: false });
    }

    render() {
        var predictions;
        if (this.state.showPredictions) {
            predictions = <PredictionList collection={this.state.predictionCollection} onSelect={this.onPredictionSelection.bind(this)} />;
        }

        var cardClassName = "card-body text-dark";
        if (this.props.miniMode) {
            cardClassName = "";
        }
        var self = this;

        return (
            <div>
                {this.renderHeader()}

                <Form
                    onChange={this.setChange.bind(this)}
                    onSubmit={this.submitSite.bind(this)} defaultValues={this.state.submittedValues}>
                    {formApi => {
                        this.formApi = formApi;

                        function showUseBudget() {
                            return <div>
                                   <div className="row">
                                <div className="col-9"><GeneralLedgerSelector accountId={self.props.initialSite.accountId} isClearable field="generalLedgerAccountCode" id="generalLedgerAccountCode" className="form-control" />
                                </div>
                                <div className="col-3">
                                        <button onClick={self.addBudgetLine.bind(self, formApi)} className="mb-4 mr-4 btn btn-success">Add New Line</button>

                                    </div>
                                    </div>
                                <div>New Accounts can be added in the GL Account Menu</div>



                                {formApi.values.glBudgetLineCollection &&
                                    formApi.values.glBudgetLineCollection.map((line, i) => (
                                        <NestedField field={['glBudgetLineCollection', i]} key={"gl-budget-line-" + i}>
                                            <GlAccountBudgetEditLine budgetLine={line} onChange={self.updateBudgetLine.bind(self,i, formApi)} />
                                           
                                        </NestedField>
                                    ))}


                                   </div>;
                        }

                       
                        var useGlBudget = this.formApi.getValue('glMonthlyBudget');
                        var manageBudgetSection;
                        if (!this.props.initialSite.hideBudget) {
                            manageBudgetSection = <div className="form-group row">
                                <label htmlFor="monthlyBudget" className="col-sm-2">Budget(monthly)</label>
                                <div className="col-sm-10">
                                    <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                        <Checkbox field="glMonthlyBudget" id="glMonthlyBudget" className="custom-control-input" disabled={!this.props.initialSite.canManageBudget} />
                                        <label className="custom-control-label" htmlFor="glMonthlyBudget">Budget Per Account</label>
                                    </div>
                                    <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                        <Checkbox field="rechargeable" id="rechargeable" className="custom-control-input" disabled={!this.props.initialSite.canManageBudget} />
                                        <label className="custom-control-label" htmlFor="rechargeable">Contract Inclusive (rechargeable spend included in budget)</label>
                                    </div>
                                    {useGlBudget && showUseBudget()}
                                    {useGlBudget && <div>Non Allocated Spend</div>}
                                    <Text field="monthlyBudget" id="monthlyBudget" className="form-control" disabled={!this.props.initialSite.canManageBudget} />
                                    

                                    <div className="custom-checkbox my-1 mr-sm-2">
                                        <span className="stockcode"><i className="icon icon-info lead" data-tip='Total monthly spend for this site ex GST'></i>
                                            <ReactTooltip /> Current Monthly Spend: {formatMoney(this.props.initialSite.monthlySpend)}</span>
                                        <span className="stockcode"><i className="icon icon-info lead" data-tip='Total monthly rechargeable spend for this site ex GST'></i>
                                            <ReactTooltip /> Current Rechargeable Spend: {formatMoney(this.props.initialSite.rechargeableSpend)}</span>
                                    </div>
                                </div>
                            </div>
                        }

                        return (
                            <form autoComplete="off" onSubmit={formApi.submitForm} id="dynamic-form">
                                <fieldset disabled={!this.state.canEdit}>
                                    {!this.props.miniMode && <div className="card card-body bg-light">
                                        <h5>
                                            <label htmlFor="site-name">Site name:</label>
                                        </h5>
                                        <Text field="name" id="site-name" className="form-control" onInput={(e) => this.validateLength(e, 50)} />
                                    </div>
                                    }

                                    {this.props.miniMode && <div className="form-group row">
                                        <label htmlFor="site-name" className={this.getLabelColClassName()}>Site Name</label>
                                        <div className={this.getValueColClassName()}>
                                            <Text field="name" id="site-name" className="form-control" onInput={(e) => this.validateLength(e, 50)} />
                                        </div>
                                    </div>
                                    }

                                    <div className={cardClassName} >
                                        {!this.props.miniMode && <h5 className="card-title"> Address Details </h5>}

                                        <div className="form-group row">
                                            <label htmlFor="addressLine1" className={this.getLabelColClassName()}>Address 1</label>
                                            <div className={this.getValueColClassName()}>
                                                <Text onFocus={this.onFocus.bind(this)} onBlur={this.onBlur.bind(this)} field="addressLine1" id="addressLine1" className="form-control" autoComplete="off" onInput={(e) => this.validateLength(e, 30)} />
                                                {predictions}
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label htmlFor="addressLine2" className={this.getLabelColClassName()}>Address 2</label>
                                            <div className={this.getValueColClassName()}>
                                                <Text field="addressLine2" id="addressLine2" className="form-control" onInput={(e) => this.validateLength(e, 30)} />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label htmlFor="addressLine3" className={this.getLabelColClassName()}>Address 3</label>
                                            <div className={this.getValueColClassName()}>
                                                <Text field="addressLine3" id="addressLine3" className="form-control" onInput={(e) => this.validateLength(e, 50)} />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label htmlFor="addressLine4" className={this.getLabelColClassName()}>Address 4</label>
                                            <div className={this.getValueColClassName()}>
                                                <Text field="addressLine4" id="addressLine4" className="form-control" onInput={(e) => this.validateLength(e, 50)} />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label htmlFor="addressLine5" className={this.getLabelColClassName()}>Address 5</label>
                                            <div className={this.getValueColClassName()}>
                                                <Text field="addressLine5" id="addressLine5" className="form-control" onInput={(e) => this.validateLength(e, 50)} />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label htmlFor="suburb" className={this.getLabelColClassName()}>Suburb</label>
                                            <div className={this.getValueColClassName()}>
                                                <Text field="suburb" required id="suburb" className="form-control" onInput={(e) => this.validateLength(e, 50)} />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label htmlFor="state" className={this.getLabelColClassName()}>State</label>
                                            <div className={this.getValueColClassName()} >
                                                <Select field="state" options={statesOptions} />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label htmlFor="postcode" className={this.getLabelColClassName()}>Postcode</label>
                                            <div className={this.getValueColClassName()}>
                                                <Text field="postcode" required id="postcode" className="form-control" onInput={(e) => this.validateLength(e, 10)} />
                                            </div>
                                        </div>
                                    </div>

                                    {!this.props.miniMode && <React.Fragment>
                                        <div className="card-body text-dark">
                                            <div className="form-group row">
                                                <label htmlFor="note" className="col-sm-2">Delivery Instructions</label>
                                                <div className="col-sm-10">
                                                    <Text field="note" onInput={(e) => this.validateLength(e, 250)} id="note" className="form-control" />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card-body text-dark">
                                            <div className="form-group row">
                                                <label htmlFor="siteSupervisor" className="col-sm-2">Supervisor</label>
                                                <div className="col-sm-10" >
                                                    <UserSelector isClearable field="siteSupervisor" isDisabled={!this.state.canEdit} />
                                                </div>
                                            </div>

                                            {manageBudgetSection}

                                            <div className="form-group row">
                                                <label htmlFor="customerReference" className="col-sm-2">
                                                    <i className="icon icon-info lead text-primary" data-tip='Your Site Code Reference'></i> Your Reference </label>
                                                <div className="col-sm-10">
                                                    <Text field="customerReference" id="customerReference" className="form-control" onInput={(e) => this.validateLength(e, 100)} />
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label htmlFor="customerCustomerReference" className="col-sm-2">
                                                    <i className="icon icon-info lead text-primary" data-tip='Your Customer Site Reference'></i> Customer Reference</label>
                                                <div className="col-sm-10">
                                                    <Text field="customerCustomerReference" id="customerCustomerReference" className="form-control" onInput={(e) => this.validateLength(e, 200)} />
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label htmlFor="siteContactName" className="col-sm-2"> Site Contact Name </label>
                                                <div className="col-sm-10">
                                                    <Text field="siteContactName" onInput={(e) => this.validateLength(e, 20)} id="siteContactName" className="form-control" />
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label htmlFor="siteContactPhone" className="col-sm-2"> Site Contact Phone </label>
                                                <div className="col-sm-10">
                                                    <Text field="siteContactPhone" onInput={(e) => this.validateLength(e, 15)} id="siteContactPhone" className="form-control" />
                                                </div>
                                            </div>

                                        </div>

                                    </React.Fragment>
                                    }

                                    <div className="row pb-2">
                                        <div className="col-6">
                                            {this.renderFinishEditingButton()}
                                        </div>
                                        <div className="col-6">
                                            {this.renderCancelButton()}

                                            {this.renderSaveButton()}
                                        </div>
                                    </div>
                                </fieldset>
                            </form>
                        )
                    }}
                </Form>
            </div>
        );
    }

}